var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.viewData.loadingPage
    ? _c("loading-list")
    : _vm.viewData.success
    ? _c(
        "b-container",
        { staticClass: "mt-3" },
        [
          _c("b-alert", { attrs: { show: "", variant: "success" } }, [
            _c("h4", { staticClass: "alert-heading mt-3" }, [
              _vm._v("Sucesso!")
            ]),
            _vm._v(" "),
            this.isAdmin
              ? _c("p", [
                  _c("a", { attrs: { href: "/#/login" } }, [
                    _vm._v("Clique aqui para entrar na aplicação.")
                  ])
                ])
              : _c("p", [_vm._v("Nova senha cadastrada")]),
            _vm._v(" "),
            _c("hr")
          ])
        ],
        1
      )
    : _c(
        "b-form",
        { staticClass: "form-signin" },
        [
          _c("img", {
            staticClass: "mb-4",
            staticStyle: { width: "19em" },
            attrs: { src: "/images/logo_veins.png", alt: "" }
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "h3 mb-3 font-weight-normal" }, [
            _vm._v("Crie sua senha")
          ]),
          _vm._v(" "),
          _c("error-container", {
            attrs: { errors: _vm.viewData.errors || [] }
          }),
          _vm._v(" "),
          !_vm.viewData.success
            ? _c(
                "b-form-group",
                [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "inputPassword" } },
                    [_vm._v("Nova Senha")]
                  ),
                  _vm._v(" "),
                  _c("b-input", {
                    attrs: {
                      type: "password",
                      pattern: "[0-9]*",
                      inputmode: "numeric",
                      max: 6,
                      state: _vm.isOk("newPassword"),
                      formatter: _vm.validatePasswordLength,
                      placeholder: "Defina uma senha",
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.save.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.state.newPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.state, "newPassword", $$v)
                      },
                      expression: "state.newPassword"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-invalid-feedback",
                    { staticStyle: { "text-align": "left" } },
                    [_vm._v(_vm._s(_vm.getError("newPassword")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c(
                "label",
                { staticClass: "sr-only", attrs: { for: "inputPassword" } },
                [_vm._v("Confirmar Nova Senha")]
              ),
              _vm._v(" "),
              _c("b-input", {
                attrs: {
                  max: 6,
                  state: _vm.isOk("newPasswordConfirm"),
                  formatter: _vm.validatePasswordLength,
                  type: "password",
                  placeholder: "Confirmar senha",
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.save.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.state.newPasswordConfirm,
                  callback: function($$v) {
                    _vm.$set(_vm.state, "newPasswordConfirm", $$v)
                  },
                  expression: "state.newPasswordConfirm"
                }
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { staticStyle: { "text-align": "left" } },
                [_vm._v(_vm._s(_vm.getError("newPasswordConfirm")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              attrs: { type: "button", disabled: _vm.viewData.loading },
              on: { click: _vm.save }
            },
            [
              _vm.viewData.loading
                ? _c("b-icon", {
                    attrs: { icon: "three-dots", animation: "cylon" }
                  })
                : _c("span", [_vm._v("Entrar")])
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }